import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const factoryItemList = this.props.factoryItemList;
    const searchData = this.props.searchData;
    const MonthList = this.props.columnNames

    return (
      <div>
        <h2><center><u>Factory Item Details Installments Report</u></center></h2>
        <div>&nbsp;</div>
        <h3><center>Group: {searchData.groupName} </center></h3>
        <h3><center>Factory: {searchData.factoryName}</center></h3>
        <h3><center>Route: {searchData.routeName === undefined ? "All Route" : searchData.routeName}</center></h3>
        <h3><center>Item Category: {searchData.itemCategoryName === undefined ? "All Item Categories" : searchData.itemCategoryName}</center></h3>
        <h3><center>Factory Items: {searchData.factoryItemName === undefined ? "All Factory Items" : searchData.factoryItemName}</center></h3>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer>
              <Table aria-label="caption table" size="small">
                <TableHead>
                  <TableRow>
                    {
                      MonthList.map((object) => {
                        return (
                          <TableCell style={{ border: 'solid 1px #ccc' }} align={'center'}>{object.title}</TableCell>
                        )
                      })
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {factoryItemList.map((data, index) => {
                    const monthPayments = {};
                    data.paymentAffectMonthArray.forEach(payment => {
                      monthPayments[payment.affectedMonth] = payment.perInstallmentPrice;
                    });

                    return (
                      <TableRow key={index}>
                        <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                          {data.routeName}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                          {data.date.split('T')[0]}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                          {data.registrationNumber}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                          {data.name}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                          {data.categoryName}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                          {data.itemName}
                        </TableCell>
                        <TableCell align={'right'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                          {data.approvedQuantity}
                        </TableCell>
                        {MonthList.slice(7, 10).map((month, i) => {
                          const currentDate = new Date();
                          const monthNumber = (currentDate.getMonth() + 1 + i) % 12 || 12;
                          const payment = monthPayments[monthNumber];

                          return (
                            <TableCell
                              key={i}
                              align={'right'}
                              component="th"
                              scope="row"
                              style={{ border: 'solid 1px #ccc' }}
                            >
                              {payment ? payment.toFixed(2) : '-'}
                            </TableCell>
                          );
                        })}
                        <TableCell align={'right'} component="th" scope="row" style={{ border: 'solid 1px #ccc' }}>
                          {data.totalPrice.toFixed(2)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}
